import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
// import ViewListIcon from '@material-ui/icons/ViewList';
import PaymentIcon from '@material-ui/icons/Payment';
import FilterList from '@material-ui/icons/FilterList';
import AssessmentIcon from '@material-ui/icons/Assessment';

import Styled from './styles';

class HeaderLeft extends Component {
  static propTypes = {
    history: PropTypes.object
  };

  onViewListClick = () => {
    this.props.history.push('/paid-companies');
  };

  onPayClick = () => {
    this.props.history.push('/pay');
  };

  onExperimentsClick = () => {
    this.props.history.push('/experiments');
  };
  onSalesUtilityClick = () => {
    this.props.history.push('/salesUtility');
  };

  render() {
    return (
      <Styled.HeaderActions>
        {/*<IconButton onClick={this.onViewListClick}>*/}
        {/*  <ViewListIcon />*/}
        {/*</IconButton>*/}

        <IconButton onClick={this.onPayClick}>
          <PaymentIcon />
        </IconButton>

        <IconButton onClick={this.onExperimentsClick}>
          <AssessmentIcon />
        </IconButton>
        <IconButton onClick={this.onSalesUtilityClick}>
          <FilterList />
        </IconButton>
      </Styled.HeaderActions>
    );
  }
}

export default HeaderLeft;



// WEBPACK FOOTER //
// ./src/organisms/HeaderLeft/index.js